import {API_BASE_PATH} from './config';

const getApiBasePath = () => API_BASE_PATH;

const shapingApiUrl = (endpoint, search = [], replace = []) => {
    const baseUrl = getApiBasePath();

    if (search.length > 0 && replace.length > 0) {
        search.forEach((currentValue, index) => {
            endpoint = endpoint.replace(`{${currentValue}}`, replace[index]);
        });

        return baseUrl + endpoint;
    }

    return baseUrl + endpoint;
};

export {shapingApiUrl};
